<template>
  <common-dialog @opened="onOpened" ref="dialog" :title="title" :modal="true" width="1200px" :in-dialog="inDialog">
    姓名：{{row[row.teachername]}}
    <teacher-chart ref="teacherChart" height="500px" />
    <template slot="footer">
      <slot name="footer">
        <el-button type="primary" size="small" @click="close">关 闭</el-button>
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import listDialogMixins from "@/mixins/listDialog";
import teacherChart from "@/components/dashboard/charts/teacherChart";

export default {
  components: { 
    commonDialog,
    teacherChart,
  },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "教师评价指标曲线图"
    },
  },
  data() {
    return {
      api: require("@/api/analyse/analyse").default,
      row: {}
    }
  },
  methods:{
    onOpened(row){
      console.log('row',row,row[row.name])
      this.row = row;
      let obj = { AnalyseId: row.AnalyseId,ClassId:row.ClassId }
      if(row.TeacherId) {
        obj[row.name] = row.TeacherId
      } else {
        obj[row.name] = row[row.name];
      }
      this.loading(true);
      this.api.getTeacherIndex(obj).then(res => {
        if(res.Code==0) {
          this.loading(false);
          // res.Data = [
            // { ExamCode: "考试1", IndexScore: 3 },
            // { ExamCode: "考试2", IndexScore: 2 },
            // { ExamCode: "考试3", IndexScore: 2.5 },
            // { ExamCode: "考试4", IndexScore: 2 },
            // { ExamCode: "考试5", IndexScore: 1 },
          // ]
          this.$refs.teacherChart.initChart(res.Data||[])
        }
      })
    },
  }
};
</script>
<style lang="scss" scoped>
</style>